import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  updateUserService,
  updateUserImageService,
  updateUserPlanService,
  getMeService,
  signInService,
  signUpService,
  forgotPasswordService,
  confirmEmailService,
  resetPasswordService,
  socialSignInService,
  socialSignUpService,
  confirmWhatsappNumberService,
  spoofedUserInService,
  spoofedUserOutService,
} from 'services/user.service';

import {
  ConfirmEmailProps,
  ConfirmWhatsappProps,
  ForgotPasswordProps,
  ResetPasswordProps,
  SignInProps,
  SignUpProps,
  SocialSignInProps,
  SocialSignUpProps,
  SpoofedInUserProps,
  UpdateUserProps,
  UploadUserImageProps,
} from 'entities/User';

// Re-hidrata o usuário logado com o plano atual (boot do app / abertura de /conta)
export const fetchCurrentUser = createAsyncThunk(
  'user/fetchCurrentUser',
  async (_, thunkApi) => {
    try {
      const response = await getMeService();

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.data));
      }

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const signIn = createAsyncThunk(
  'user/signIn',
  async (data: SignInProps, thunkApi) => {
    try {
      const response = await signInService(data);

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('token', JSON.stringify(response.data.data.token));
      }

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const socialSignIn = createAsyncThunk(
  'user/socialSignIn',
  async (data: SocialSignInProps, thunkApi) => {
    try {
      const response = await socialSignInService(data);

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('token', JSON.stringify(response.data.data.token));
      }

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const signUp = createAsyncThunk(
  'user/signUp',
  async (data: SignUpProps, thunkApi) => {
    try {
      const response = await signUpService(data);

      if (response.data.success && response.data.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('token', JSON.stringify(response.data.data.token));
      }
      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const socialSignUp = createAsyncThunk(
  'user/socialSignUp',
  async (data: SocialSignUpProps, thunkApi) => {
    try {
      const response = await socialSignUpService(data);

      if (response.data.success && response.data.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('token', JSON.stringify(response.data.data.token));
      }
      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const confirmEmail = createAsyncThunk(
  'user/confirmEmail',
  async (data: ConfirmEmailProps, thunkApi) => {
    try {
      await confirmEmailService(data);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const confirmWhatsapp = createAsyncThunk(
  'user/confirmWhatsapp',
  async (data: ConfirmWhatsappProps, thunkApi) => {
    try {
      await confirmWhatsappNumberService(data);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  'user/forgotPassword',
  async (data: ForgotPasswordProps, thunkApi) => {
    try {
      await forgotPasswordService(data);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const resetPassword = createAsyncThunk(
  'user/resetPassword',
  async (data: ResetPasswordProps, thunkApi) => {
    try {
      await resetPasswordService(data);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateUser = createAsyncThunk(
  'user/updateUser',
  async ({ isFinishUser = false, ...data }: UpdateUserProps, thunkApi) => {
    try {
      const response = await updateUserService({ isFinishUser, ...data });

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.data));
      }

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateUserImage = createAsyncThunk(
  'user/updateUserImage',
  async (data: UploadUserImageProps, thunkApi) => {
    try {
      const response = await updateUserImageService(data);

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.data));
      }

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateUserPlan = createAsyncThunk(
  'user/updateUserPlan',
  async (planName: string, thunkApi) => {
    try {
      const response = await updateUserPlanService(planName);

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.data));
      }

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const spoofedOutUser = createAsyncThunk(
  'user/spoofedOutUser',
  async (_, thunkApi) => {
    try {
      const response = await spoofedUserOutService();

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('token', JSON.stringify(response.data.data.token));
      }

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const spoofedInUser = createAsyncThunk(
  'user/spoofedInUser',
  async (data: SpoofedInUserProps, thunkApi) => {
    try {
      const response = await spoofedUserInService(data);

      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('token', JSON.stringify(response.data.data.token));
      }

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
